/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251230
*/
'use strict';

import {
    savePromise
} from './ctssJQuery.js';
import {
    initGroupCtrlsAsync,
    initGroupsDDL
} from './snGroupCtrls.js'
import {
    initGroupsAsync
} from './snGroups.js'
import {
    appDebugMode,
    Features,
    setMenu
} from './snSite.js';

const initAsync = async () => {
    setMenu();

    $('#editTitle,#editMsg').on('input', () => {
        $('#btnSend').prop('disabled',
            ($('#editTitle').val().length === 0 || $('#editMsg').val().length === 0));
    });

    try {
        const data = await initGroupCtrlsAsync({
            featureID: Features.Announcements,
            useDDL: true
        });
        let lblAudienceDesc = 'A quick notification is a one time push notification that will be sent to';
        if (data.hasGroups) {
            lblAudienceDesc += ' the entire congregation or a selected group.';
            $('#divGroupDDL,#divAudience').removeClass('hidden');
        } else {
            lblAudienceDesc += ' all church members.';
        }
        lblAudienceDesc +=
            ' If you would like to add an image, link, or more information, consider using the Announcements feature.';
        $('#lblAudienceDesc').text(lblAudienceDesc);

        $('#btnSend').on('click', async () => {

            const notifMsg = {
                title: $('#editTitle').val(),
                msg: $('#editMsg').val(),
                groupID: data.hasGroups ? parseInt($('#hiddenGroupID').val(), 10) : 0
            }

            await savePromise({
                url: 'Notifications/Push',
                data: notifMsg,
                btnId: 'btnSend'
            })
        });

    }
    catch (error) { }
};

window.snNotifications = {
    initAsync
}
